// SVG/image imports resolve as strings (Vite) or { src } objects (Next.js)
// depending on the bundler. Normalize to a usable URL string either way.
export const toSrc = (imported: string | { src: string }): string =>
  typeof imported === "string" ? imported : imported.src;
